import { SkeletonSizeBase } from './SkeletonSizesBase';
import { Component, Input } from '@angular/core';
import { ChartType, LegendPosition } from './Enums';

@Component({
  template: ''
})
// tslint:disable-next-line:component-class-suffix
export class SkeletonChartBase extends SkeletonSizeBase {
  @Input('skc-image-src') imageSrc;
  @Input('skc-custom-image') customImage = false;
  @Input('skc-legend') legend = true;
  @Input('skc-image-color') imageColor;
  @Input('skc-height') height;
  @Input('skc-width') width;
  @Input('skc-legend-width') legendWidth;
  @Input('skc-legend-height') legendHeight;
  @Input('skc-total-legends') totalLegends;
  @Input('skc-legend-position') legendPosition: LegendPosition;
  @Input('skc-chart-type') chartType: ChartType;
}
